<div class="starry-tip-wrapper">
    <div class="container">
        <div class="row">
                <div class="img-wrap col-2 px-0">
                    <img *ngIf="data?.starImage != null" src="{{data?.starImage['url']}}" (error)= "data?.starImage['url'] ='assets/icon/starry_tip_default.svg'" alt="stars">
                    <img *ngIf="data?.starImage == null" src="assets/icon/starry_tip_default.svg" alt="stars">
                </div>
                 <div class="text-content col-8">
                    <h5>{{data?.starryTipName}}</h5>
                    <p>{{data?.starryTipContent}}
                       </p>
                </div>
                <div class="close col-2 text-right">
                    <img src="assets/icon/Close-white.png" alt="close" (click)="close(data);starryTipCloseGA()">
                </div>
        </div>
    </div>
</div>
